<template>
  <a class="row news-feed-item" :class="containerModifier" :href="url" :target="target">
    <div v-if="shouldShowImage" class="column small-4 news-feed-item__image">
      <img :src="getItemImage(data)" @error="onImageLoadError" />
    </div>
    <div class="column news-feed-item__content" :class="contentModifier">
      <h4>{{ data.title }}</h4>
      <h5 v-if="showSubtitle" class="news-feed-item__subtitle">
        {{ data.origin.title }}
      </h5>
      <p v-if="data.summary" v-html="data.summary.content"></p>
    </div>
  </a>
</template>

<script src="./news-feed-item.js"></script>
<style src="./news-feed-item.scss" lang="scss"></style>
